export default __webpack_public_path__ + "assets/fonts/0f9b0c9cf6182aaa29d6c3f3a63a8e6c.woff2";